<template>
    <div id="MobileNav">
        <b-navbar class="py-0 pl-0 row bg-white">
            <div class="col-3 col-sm-4 nav-button">
                <b-button @click="togglePageNav">
                    <i class="fas fa-times fa-2x brand-primary"  v-if="pageNav"></i>
                    <i class="fas fa-bars fa-2x brand-primary" v-else></i>
                </b-button>
            </div>
            <b-navbar-brand class="col-6 col-sm-4 px-0" @click="navigate('eap')">
                <img src="/img/logo-spectrum-life.svg" />
            </b-navbar-brand>
        </b-navbar>
        <b-collapse :visible="pageNav" class="col-12 page-nav bg-white" is-nav>
            <b-navbar-nav class="" align="center" >

                <b-nav-item @click="navigate('eap')" class="mx-5 py-4 brand-secondary border-brand-primary" :class="{active : currentPage === 'eap'}"
                >EAP</b-nav-item>
                <!--<b-nav-item @click="navigate('eapUK')" class="mx-5 py-4 brand-secondary border-brand-primary" :class="{active : currentPage === 'eapUK'}"
                >EAP UK</b-nav-item>-->
                <b-nav-item @click="navigate('wellbeing')" class="mx-5 py-4 brand-secondary border-brand-primary" :class="{active : currentPage === 'Wellbeing'}"
                >COVID-19</b-nav-item>
                <b-nav-item @click="navigate('info')" class="mx-5 py-4 border-brand-primary"  :class="{active : currentPage === 'general-info'}">General Info</b-nav-item>
                <b-nav-item @click="navigate('beCalm')" class="mx-5 py-4 brand-secondary border-brand-primary" :class="{active : currentPage === 'beCalm'}"
                >beCalm</b-nav-item>
                <b-nav-item href="https://wellbeing.spectrum.life/wellbeing-series-2020/" target="_blank" class="mx-5 py-4 brand-secondary border-brand-primary"
                >Wellbeing Series</b-nav-item>
            </b-navbar-nav>
        </b-collapse>
    </div>
</template>

<script>
    export default {
        name: "MobileNav",
        components: {},
        data() {
            return {
                pageNav: false,
            };
        },
        methods: {
            navigate(url) {
                this.$router.push({name: url})
                this.pageNav = false
            },
            togglePageNav(){
                this.pageNav = !this.pageNav
            },
        },
        computed: {
            currentPage(){
                return this.$route.name
            },
        }
    };
</script>
<style lang="less">
    #MobileNav {
        position: absolute;
        width: 100%;
        top: 0;
        left: 0;
        z-index: 100;
        .navbar {
            height: 80px;
            .nav-button {
                text-align: center;
                .btn {
                    background: transparent;
                }
            }
            .navbar-brand{
                width: 40%;
                background-color: #fff;
                text-align: center;
                cursor: pointer;
                height: 80px;
                max-width: 247px;
                align-items: center;
                display: flex;
                img{
                    max-width: 100%;
                    margin: auto;
                    max-height: 80%;
                    //this section to be edited when BOI assets are ready
                }
            }
        }
        .page-nav {
            .nav-item {
                position: relative;
                border-bottom: solid 1px;
                a {
                    font-size: 1.7rem;
                    font-family: "FilsonProBook", sans-serif;
                }
                &.active {
                    a {
                        font-family: "FilsonProBold", sans-serif;
                    }
                    &:before {

                    }
                }
            }
            .dropdown-menu{
                position: relative;
            }
            .plans{
                font-size: 1.7rem;
            }
        }
    }
</style>